import { apiClient, toCamelCase } from "./client";
import type { Token, LoginRequest, User } from "@/types";

export const authApi = {
  login: async (data: LoginRequest): Promise<Token> => {
    const response = await apiClient.post("/auth/login", data);
    return toCamelCase(response.data) as Token;
  },

  logout: async (): Promise<void> => {
    await apiClient.post("/auth/logout");
  },

  refreshToken: async (refreshToken: string): Promise<Token> => {
    const response = await apiClient.post("/auth/refresh", {
      refresh_token: refreshToken,
    });
    return toCamelCase(response.data) as Token;
  },

  getCurrentUser: async (): Promise<User> => {
    const response = await apiClient.get("/auth/me");
    return toCamelCase(response.data) as User;
  },

  updatePassword: async (
    currentPassword: string,
    newPassword: string
  ): Promise<void> => {
    await apiClient.put("/auth/password", {
      current_password: currentPassword,
      new_password: newPassword,
    });
  },
};
